import script from "./edit-invoice.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-invoice.vue?vue&type=script&setup=true&lang=js"

import "./edit-invoice.vue?vue&type=style&index=0&id=65621774&lang=css"

const __exports__ = script;

export default __exports__